var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b-tooltip',{attrs:{"label":_vm.$t(("Orders." + _vm.state)),"position":_vm.tooltipPosition,"type":_vm.type}},[_c('b-icon',{class:_vm.stateComunication.css,attrs:{"icon":_vm.stateComunication.icon,"size":"is-small"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d59f268","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/miscellaneous/TransportCommunications.vue
// module id = null
// module chunks = 